/**
 * Whether this BUILD shows the subscription surfaces at all — the Voice row in the
 * main menu, the quota sheet at the mic, the mic gate, and the draft legal pages.
 *
 * Owner, 2026-09-10 morning: 目前因為 subscription 這個欄位還沒有正式的測試通過, 我們可以先把它
 * 拿掉, 剩餘其他的東西全部都可以推到 prod. The code stayed; the build decided: OFF unless
 * the build said `VITE_BILLING_UI=on`, because while prod's BFF had no webhook door
 * and its meter allowed the old 60 minutes, the safe mistake was a bundle WITHOUT the
 * paywall.
 *
 * Owner, 2026-09-10 evening, after both tills were proven on dev (a real sandbox
 * purchase on his iPhone, a Stripe test-card purchase in his browser, Manage, the
 * receipt): 測過了可以推 prod. From here the paywall IS the product, so the default
 * flips: ON unless the build says `VITE_BILLING_UI=off`. The safe mistake is now the
 * other one — a prod build that forgot an env var must not silently hide the only
 * way to buy.
 *
 * Read at call time, not at module load, so a test can flip it with vi.stubEnv.
 */
export function billingUiOn(): boolean {
  const env = import.meta.env as Record<string, string | undefined>
  return env['VITE_BILLING_UI'] !== 'off'
}
